import { IRootState } from '../../../../../store'
import { IBurnsState } from '../store/burns.types'

export const getBurnsSelector = (state: IRootState): IBurnsState => state.burns
